import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CookieAdapterService } from '../../core/cookie-adapter.service';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { OeAppService } from '../oe-app.service';
import { EduSynchSsoDto } from './edusynch-sso-dto';
import { OeAppPersonService } from '../oe-app-person.service';

@Injectable({ providedIn: 'root' })
export class EduSynchModalService {
  COOKIE_NAME = '__edusynch';
  COOKIE_EXPIRATION_DAYS = 7;

  constructor(
    private readonly oeApp: OeAppService,
    private readonly oeAppPersonService: OeAppPersonService,
    private readonly http: HttpClient,
    private readonly cookieService: CookieAdapterService,
    private readonly modalService: NgbModal
  ) {}

  getUrl(): Observable<string> {
    const url = `${this.oeApp.thirdPartyServiceHost}/v1/edusynch/sso`;
    const { contactId } = this.oeAppPersonService.getPersonData();

    const cookie = this.cookieService.get(this.COOKIE_NAME);
    const [cookieContactId, cookieUrl] = cookie && cookie.split(';');

    if (cookieContactId === contactId && cookieUrl) {
      return of(cookieUrl);
    }

    return this.http
      .get<EduSynchSsoDto>(url, { params: { contactId } })
      .pipe(
        map((result) => {
          this.cookieService.put(this.COOKIE_NAME, `${contactId};${result.sso_url}`, this.COOKIE_EXPIRATION_DAYS);
          return result.sso_url;
        })
      );
  }
}



// WEBPACK FOOTER //
// ./ts/app/shared/edusynch-modal/edusynch-modal.service.ts